/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './surgical-appointment-attribute-type.reducer';

export const SurgicalAppointmentAttributeType = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const surgicalAppointmentAttributeTypeList = useAppSelector(state => state.surgicalAppointmentAttributeType.entities);
  const loading = useAppSelector(state => state.surgicalAppointmentAttributeType.loading);
  const totalItems = useAppSelector(state => state.surgicalAppointmentAttributeType.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="surgical-appointment-attribute-type-heading" data-cy="SurgicalAppointmentAttributeTypeHeading">
        <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.home.title">
          Surgical Appointment Attribute Types
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/surgical-appointment-attribute-type/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.home.createLabel">
              Create new Surgical Appointment Attribute Type
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.surgicalAppointmentAttributeType.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {surgicalAppointmentAttributeTypeList && surgicalAppointmentAttributeTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('format')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.format">Format</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('format')} />
                </th>
                <th className="hand" onClick={sort('sortOrder')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.sortOrder">Sort Order</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sortOrder')} />
                </th>
                <th className="hand" onClick={sort('retiredReason')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.retiredReason">Retired Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('retiredReason')} />
                </th>
                <th className="hand" onClick={sort('retired')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.retired">Retired</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('retired')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.addedBy">Added By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.modifiedBy">Modified By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.theatre">Theatre</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.procedure">Procedure</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {surgicalAppointmentAttributeTypeList.map((surgicalAppointmentAttributeType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/surgical-appointment-attribute-type/${surgicalAppointmentAttributeType.id}`}
                      color="link"
                      size="sm"
                    >
                      {surgicalAppointmentAttributeType.id}
                    </Button>
                  </td>
                  <td>{surgicalAppointmentAttributeType.name}</td>
                  <td>{surgicalAppointmentAttributeType.description}</td>
                  <td>{surgicalAppointmentAttributeType.format}</td>
                  <td>{surgicalAppointmentAttributeType.sortOrder}</td>
                  <td>{surgicalAppointmentAttributeType.retiredReason}</td>
                  <td>{surgicalAppointmentAttributeType.retired ? 'true' : 'false'}</td>
                  <td>{surgicalAppointmentAttributeType.active ? 'true' : 'false'}</td>
                  <td>{surgicalAppointmentAttributeType.cursor}</td>
                  <td>{surgicalAppointmentAttributeType.lastupdated}</td>
                  <td>{surgicalAppointmentAttributeType.microSec}</td>
                  <td>{surgicalAppointmentAttributeType.timestampentry}</td>
                  <td>
                    {surgicalAppointmentAttributeType.addedBy ? (
                      <Link to={`/hospital-manager/${surgicalAppointmentAttributeType.addedBy.id}`}>
                        {surgicalAppointmentAttributeType.addedBy.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {surgicalAppointmentAttributeType.modifiedBy ? (
                      <Link to={`/hospital-manager/${surgicalAppointmentAttributeType.modifiedBy.id}`}>
                        {surgicalAppointmentAttributeType.modifiedBy.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {surgicalAppointmentAttributeType.hospital ? (
                      <Link to={`/hospital/${surgicalAppointmentAttributeType.hospital.id}`}>
                        {surgicalAppointmentAttributeType.hospital.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {surgicalAppointmentAttributeType.theatre ? (
                      <Link to={`/operation-theatre/${surgicalAppointmentAttributeType.theatre.id}`}>
                        {surgicalAppointmentAttributeType.theatre.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {surgicalAppointmentAttributeType.procedure ? (
                      <Link to={`/hospital-procedure/${surgicalAppointmentAttributeType.procedure.id}`}>
                        {surgicalAppointmentAttributeType.procedure.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/surgical-appointment-attribute-type/${surgicalAppointmentAttributeType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/surgical-appointment-attribute-type/${surgicalAppointmentAttributeType.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/surgical-appointment-attribute-type/${surgicalAppointmentAttributeType.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.home.notFound">
                No Surgical Appointment Attribute Types found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={surgicalAppointmentAttributeTypeList && surgicalAppointmentAttributeTypeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SurgicalAppointmentAttributeType;
